import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';

// https://atlassian.design/components/primitives/responsive/breakpoints
export const breakpointValues = {
  xxs: 0,
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1440,
  xl: 1760
};
export let Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint["xxs"] = "xxs";
  Breakpoint["xs"] = "xs";
  Breakpoint["sm"] = "sm";
  Breakpoint["md"] = "md";
  Breakpoint["lg"] = "lg";
  Breakpoint["xl"] = "xl";
  return Breakpoint;
}({});
export const useResponsiveBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(() => getBreakpoint());
  function getBreakpoint() {
    const width = window.innerWidth;
    if (width < breakpointValues.xs) return {
      value: breakpointValues.xxs,
      id: Breakpoint.xxs
    };
    if (width < breakpointValues.sm) return {
      value: breakpointValues.xs,
      id: Breakpoint.xs
    };
    if (width < breakpointValues.md) return {
      value: breakpointValues.sm,
      id: Breakpoint.sm
    };
    if (width < breakpointValues.lg) return {
      value: breakpointValues.md,
      id: Breakpoint.md
    };
    if (width < breakpointValues.xl) return {
      value: breakpointValues.lg,
      id: Breakpoint.lg
    };
    return {
      value: breakpointValues.xl,
      id: Breakpoint.xl
    };
  }
  useEffect(() => {
    const calcInnerWidth = debounce(() => {
      setBreakpoint(getBreakpoint());
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);
  return breakpoint;
};